export default __webpack_public_path__ + "static/media/twitter-blue.48ff8634.svg";